module.exports = {
  easing: {
    base: 'ease-in-out',
  },
  timing: {
    base: '0.3s',
    fast: '0.15s',
  },
};
